export enum NotificationOption {
	IN_APP = 'inApp',
	EMAIL = 'email',
	BOTH = 'both'
}
